module.exports = __webpack_public_path__ + "favicon.ico?8c00dcdf1dd3374fe528a69fad4bdfaa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.ico
// module id = 530
// module chunks = 66